//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from '@/components/autoscale/loader';
import EventCard from '@/components/events/card.vue';

export default {
  components: {
    Loader,
    EventCard,
  },
  data() {
    return {
      buzy: true,
      events: [],
    };
  },
  async fetch() {
    await this.getEvents();
    this.buzy = false;
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
  },
  methods: {
    async getEvents() {
      let response;
      try {
        let api =
          this?.$nuxt?.$config?.CMS_REST_API ||
          'https://cms.ebaconline.com.br/api/';
        const url = `${api}/public/v2/events/`;

        const directions = this.event?.directionId
          ? [this.event?.directionId]
          : [];
        const exclude = this.event?.eventId ? [this.event?.eventId] : [];

        response = await this.$axios({
          method: 'get',
          url,
          params: {
            limit: 3,
            offset: 0,
            directions,
            exclude,
            published: true,
          },
        });
      } catch (e) {
        console.error(e);
      }

      this.events = response.data.data.data;
    },
  },
};
